import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { LOAN_UPDATE_ASSET_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class UpdateLoanAsset extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = [];

  url = LOAN_UPDATE_ASSET_URL;

  constructor(applicantId, finAnalysisId, financialId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [applicantId, finAnalysisId, financialId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
